import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../api/firebase";
import { nbfGetDepartments } from "../../api/restApi";
import { DepartmentType, DepartmentTypeAutoComplete } from "../../components/AutoComplete/DepartmentType";
import { departmentsData, setDepartments } from "../../store/reducer/departmentsSlice";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import MaterialTable from "../setting/Tables/MaterialTable";
  export const Departments = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const { departments } = useAppSelector(departmentsData);
    const dispatch = useAppDispatch();
    const collectionName = "departments";
  
    const nbfCustomerInfo = async () => {
      let dep = await nbfGetDepartments();
      dispatch(setDepartments(dep));
    };
  
    const handleCreateNewRow = async (values) => {
      try {
        // console.log('*********',values)
  
        if (!values || Object.keys(values).length === 0) {
          alert("Please enter valid data");
          return;
        }
  
        await addDoc(collection(db, collectionName), values);
  // ----------------------------------------------------------------------------
      //Need to get newly created ID of the customer to create level3 code with it
      //Need to create customer from end-point
        // let createLevel3Code =await CreateNewCustomer({...values},level_3,"")
  // ----------------------------------------------------------------------------
        // console.log(response);
        // const docRef = doc(collection(db, collectionName), "id");
        // await setDoc(docRef, values);
        toast.success("Successfully add new item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        nbfCustomerInfo();
      } catch (error) {
        // console.log(error);
        console.log(error);
        toast.error("Failed to add new item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
  
    useEffect(() => {});
    const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
      // if (!Object.keys(validationErrors).length) {
  
      try {
        let id = row.getValue("id").toString();
        await updateDoc(doc(db, collectionName, id), values);
  
        toast.success("Successfully update  item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        nbfCustomerInfo();
      } catch (error) {
        // console.log(error);
        toast.error("Failed to  update  item!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
  
      exitEditingMode(); //required to exit editing mode and close modal
      // }
    };
    const handleDeleteRow = useCallback(async (row) => {
      if (
        !window.confirm(`Are you sure you want to delete ${row.getValue("Name")}`)
      ) {
        return;
      }
    });
  
    // "name_english": "lasani bakers-terlai",
    // "id": 90180,
    // "address_english": "terlai chowk",
    // "city_english": "Islamabad",
    // "city_urdu": "اسلام آباد",
    // "address_urdu": "",
    // "name_urdu": ""
    const columns = useMemo(() => [
      {
        accessorKey: "id",
        header: "ID",
        enableColumnOrdering: false,
        enableEditing: false, //disable editing on this column
        enableSorting: false,
        size: 80,
      },
      {
        accessorKey: "name",
        header: "Name",
        size: 140,
      },
     {
        accessorKey: "dType",
        header: "Type",
        size: 140,
        editVariant: "select",
      editSelectOptions: DepartmentType,


     },
    ]);
    return (
      <>
        <Stack spacing={4} marginX={4} mt={1}>
          <MaterialTable
            setCreateModalOpen={setCreateModalOpen}
            tableData={departments}
            handleSaveRowEdits={handleSaveRowEdits}
            //   handleCancelRowEdits={handleCancelRowEdits}
            handleDeleteRow={handleDeleteRow}
            columns={columns}
            csvFileName="departments"
          ></MaterialTable>
        </Stack>
        <CreateNewAccountModal
          columns={columns}
          open={createModalOpen}
          onClose={() => setCreateModalOpen(false)}
          onSubmit={handleCreateNewRow}
        />
      </>
    );
  };
  
  //example of creating a mui dialog modal for creating new rows
  export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit }) => {
    const initialValues = {
      // Address: '',
      // City: '',
      // Name: '',
      // id: '',
      // Email: ''
    };
    const [values, setValues] = useState(initialValues);
  
    // useEffect(() => {
    //   setValues(initialValues);
    // }, []);
  
    const handleSubmit = async () => {
      onSubmit(values);
      onClose();
    };
  
    return (
      <Dialog open={open}>
        <DialogTitle textAlign="center">Create New Department</DialogTitle>
        <DialogContent>
          <form onSubmit={(e) => e.preventDefault()}>
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "300px", sm: "360px", md: "400px" },
                gap: "1.5rem",
              }}
            >
              {columns.map((column) => {
                // Remove columns from new update
                if (column.accessorKey !== "id") {
                  if (column.accessorKey === "dType") {
                     return (
                      <DepartmentTypeAutoComplete
                        value={values.dType || null}
                        onChange={(e, newValue) =>
                          setValues({ ...values, dType:newValue})
                        }/>
                     )
                  }
                  else {
                  return (
                    <TextField
                      key={column.accessorKey}
                      label={column.header}
                      name={column.accessorKey}
                      onChange={(e) =>
                        setValues({ ...values, [e.target.name]: e.target.value })
                      }
                    />
                  );
                    }
                }
              })}
            </Stack>
          </form>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="secondary" onClick={handleSubmit} variant="contained">
            Create New Department
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  